import React, { useCallback, useEffect, useState , useRef} from 'react';
import {
  Button,
  Loader,
  NavDivider,
  Navigation,
  ScrollableDynamicTable,
  ExpandableSidebar,
  TOAST as Alert,
  StatusChip,
  Modal,
  Input,
  SidePane,
  SelectInput,
} from 'retro';
import {TOAST} from "retro/index";
import { get, post } from 'App/Network/Axios';
import OpenIcon from '@atlaskit/icon/glyph/open';
import moment from 'moment';
import { DownloadCsv } from 'retro/Utils';
import FilterDropDown from 'App/Components/Filter/FilterDropDown';
import useConfigHook from 'App/Hooks/useConfigHook';

export default function ApTicket() {
  let [loading, setLoading] = useState(false);
  const [id, setId] = useState(undefined);
  let filter = {
    status : [] 
   }
   const CONFIG = useConfigHook()
  const [search, setSearch] = useState({
    page: 0,
    filter
  });
  const [AllClients, setAllClients] = useState();
  const MODULE = useRef();
  const TRANSID = useRef();
  const ISSUE = useRef();
  const CLIENT = useRef();
  const REMARK = useRef();
  const [Data, SetData] = useState({
    total: 0,
    currentPage: 0,
    totalPages: 0,
    items: [],
  });
  const [range,setRange] = useState(undefined)
  const [ticketDetailPane, setTicketDetailPane] =  useState(false)
  const [ticketDetail, setTicketDetail] = useState(undefined)
  const [ticketId, setTicketId] = useState(undefined);
  const [createTicketModal, setCreateTicketModal] = useState(false)
    useEffect(
      ()=>{
      get(
        `support/all/tickets`,
        (e, r) => {
            if (r) {
                SetData({
                    ...r,
                    currentPage: r.currentPage > 0 ? r.currentPage : 0,
                    totalPages: r.totalPages > 0 ? r.totalPages : Data.totalPages,
                    total: r.total > 0 ? r.total : Data.total,
                  });
              } else {
                Alert.handleError(e);
              }
        },
        {
            offset: search.page,
            start: search.startDate,
            end: search.endDate,
            status: search.filter.status,
            module:"Vendor Payout"
        })},[search]
  );

  useEffect(()=>{
    if(range){
        setSearch({
            ...search,
            startDate:range.startDate,
            endDate:range.endDate
        })
    }else{
        setSearch({
            ...search,
            startDate:undefined,
            endDate:undefined
        })
    }
},[range])

  
  const handleClose = (remark) => {
    if(remark.length<1)
    {
        TOAST.error("Enter Remark");
        return
    }
    if(remark.length>200)
    {
        TOAST.error("Word limit exceeded, Word Limit 200 words")
        return
    }
    post(`support/${ticketId}/updateStatus/${id}`,{
      status:"Close",
      remark:remark
    },(e,r)=>{
      setTicketDetailPane(false)
      if(r && r.status===true)
      {
        TOAST.success("Ticket Successfully Closed" )
        setSearch({
          page:0,
          filter
        })
        return
      }
      else if(e){
        TOAST.handleError(e)
      }
    })
  }

  return (
    <div >
    <div style={{display:'flex' , justifyContent:'space-between'}}>
      <Navigation
        title='Account Payable Support Tickets'
        description='All the Support tickets raised are displayed here...'
        style={{marginLeft:'20px'}}
      />  
   {CONFIG?.roles.includes("REPORTS") && <div style={{display:'flex', marginTop:'-10px'}}>
         <Button
          onClick={() => {
            setLoading(true)
            get(
                `support/all/tickets`,
                (e, r) => {
                  if (r && Array.isArray(r.items)) {
                    setLoading(false)
                    let data = [];
                    let headers = [
                      'Ticket Id',
                      'Raised By Name',
                      'Raised By Email',
                      'Created On Date',
                      'Ticket Status',
                      'Client Name',
                      'Client Id',
                      'Module Name',
                      'Transaction Id',
                      'Issue Description',
                      'Closed On',
                      'Closure Remark'
                    ];
                    data.push(headers);
                    r.items.forEach((item) => {
                      if (item.module === "Vendor Payout") {
                        let line = [];
                        line.push(item.ticketId || '-');
                        line.push(item.raisedBy.name || '-');
                        line.push(item.raisedBy.email || '-');
                        line.push(moment(item.createdAt).format('DD MMM YYYY HH:mm') || '-');
                        line.push(item.status || '-');
                        line.push(item.clientName || '-');
                        line.push(item.clientId || '-');
                        line.push(row?.module==='Vendor Payout' && 'Account Payable' || '-');
                        line.push(item.transactionID || '-');
                        line.push(item.description || '-');
                        line.push(
                          item.closureOn
                            ? moment(item.closureOn).format('DD MMM YYYY HH:mm')
                            : '-'
                        );
                        line.push(item.closureRemarks || '-');
                        data.push(line);
                      }
                    });
                    DownloadCsv(`AccountPayablePSupportTickets_${moment().format('DD_MM_YYYY')}.csv`, data);
                  } else {
                    console.error("No items found or response is invalid");
                  }
                },
                {
                    offset: search.page,
                    start: search.startDate,
                    end: search.endDate,
                    status: search.filter.status
                },
                [search]
              );
            }}              
            loading={loading}
            style={{ zIndex: 11 }}
            className='btn absolute top-3 right-6 btn-primary'
        >
          <i className='fa fa-download mr1' />
          Download Data
        </Button>
        </div>}
        </div>
        <div style={{marginTop:'-5px', marginBottom:'-10px'}}>
           <FilterDropDown shown={true} dateFilter={{
				range,
				setRange
			}}
            setFilters={filter => {
				setSearch({
					...search,
					filter: {
						status: filter.status,
					},
					page: 0
				})
			}} filters={{
				status: search.filter.status || []
			}}
            selectionType={{status:'single'}}
            filterIcondisplay={false}
            color={'White'}
            types={['Status']} choices={{status:['Open','Close']}}/>
        </div>
      <NavDivider/>
      <ScrollableDynamicTable 
        setSearch={(search) => {
          setSearch({
            ...search,
            page: 0,
          });
        }}
        search={search}
        tableStyle={{
          borderSpacing: 2,
        }}
        setPage={(page) => {
          setSearch({
            ...search,
            page,
          });
        }}
        data={{
          current: Data.currentPage,
          total: Data.totalPages,
          items: Data.items.map((item) => {
            return {
              content: item,
              render: [
                {
                    weight: 1.75,
                    children: <p className='truncate text-underline' onClick={() => {
                      get(`/support/${item.ticketId}`,(e,r)=>{
                        if(r)
                        {
                          setTicketDetail(r.ticket)
                        }
                      });
                      setTicketId(item?.ticketId)
                      setId(item?.clientId)
                      setTicketDetailPane(true)
                      }}>{item.ticketId}
                      </p>,
                  },
                {
                  weight: 1.5,
                  children: (
                    <>{moment(item.createdAt).format('DD MMM YYYY HH:mm a')}</>
                  ),
                },
                {
                    weight: 1.25,
                    children: (
                      <>{item?.module==='Vendor Payout' && 'Account Payable'}</>
                    ),
                  },
                {
                  weight: 1.25,
                  children: (
                    <div>
                      <p className='truncate'>{item.raisedBy.name}</p>
                      <p className='text-small truncate'>{item.raisedBy.email}</p>
                    </div>
                  ),
                },
                {
                    weight: .75,
                    children: (
                      <div>
                        <StatusChip className='truncate' status={item.status}/>
                      </div>
                    ),
                  },
                  {
                    weight: 1.5,
                    children: (
                      <div>
                        <p className='truncate'>{item?.closureOn ? moment(item?.closureOn).format('DD MMM YYYY HH:mm a')  : "-"}</p>
                        </div>
                    )
                  },{
                    weight: .75,
                    buttons: [
                      {
                        title: 'View',
                        className: "btn-secondary btn-sm",
                        before: <OpenIcon size='small' />,
                        onClick: () => {
                          get(`/support/${item.ticketId}`,(e,r)=>{
                            if(r)
                            {
                              setTicketDetail(r.ticket)
                            }
                          });
                          setTicketId(item?.ticketId)
                          setId(item?.clientId)
                          setTicketDetailPane(true)
                          }},
                      ,
                    ],}
              ],
            };
          }),
        }}
        headers={[
          {
            weight: 1.75,
            title: 'Ticket Id',
          },
          {
            weight: 1.5,
            title: 'Created On',
          },
          {
            weight: 1.25,
            title: 'Module Name',
          },
          {
            weight: 1.25,
            title: 'Issue Raised By',
          },
          {
            weight: .75,
            title: 'Status',
          },
          {
            weight: 1.5,
            title: 'Closed On',
          },
          {
            weight: .75,
            title: 'Action',
            style: {
              justifyContent: 'end',
            },
          }
        ]}
      />
      {
            ticketDetailPane &&
            <SidePane width={450}  description="" title={"Ticket Details"} onClose={()=>{
                setTicketDetailPane(false)
            }}>
              <div>
                <div className='mt1'>
                <h3 className='mb1'>Details</h3>
                  <div className='flex'><h4 className='mb1'>TicketID - </h4>  <p>{ticketDetail?.ticketId}</p></div>
                  <div className='flex'><h4 className='mb1'>Issue Raised By - </h4>  <p>{ticketDetail?.raisedBy?.name} ( {ticketDetail?.raisedBy?.email} )</p></div>
                  <div className='flex'><h4 className='mb1'>Created On - </h4> <p> {moment(ticketDetail?.createdAt).format("DD-MMM-YYYY HH:mm a")}</p></div>
                  <div className='flex'><h4 className='mb1'>Status - </h4>  <p>{ticketDetail?.status}</p></div>
                  <div className='flex'><h4 className='mb1'>Client Name - </h4>  <p>{ticketDetail?.clientName || '-'} ({ticketDetail?.clientId || '-'})</p></div>
                  <div className='flex'><h4 className='mb1'>Module Name - </h4>  <p>{ticketDetail?.module==='Vendor Payout' && 'Account Payable' || '-'}</p></div>
                  <div className='flex'><h4 className='mb1'>Transaction Id - </h4>  <p>{ticketDetail?.transactionID || '-'}</p></div>
                  <div className='flex'><h4 className='mb1'>Issue Description - </h4>  <p>{ticketDetail?.description}</p></div>
                  {ticketDetail?.status==='Close' &&   <div className='flex'><h4 className='mb1'>Closure Remark - </h4>  <p>{ticketDetail?.closureRemarks}</p></div>}
                 {ticketDetail?.status==='Open' && <div className='mt4'> <h4 className='mb1 '>Write Your Closure Remark Here*</h4>
                <textarea
                rows="4"
                cols="50"
                ref={REMARK}
                style={{
                    resize: "vertical", 
                    width: "100%", 
                    border: "1px solid #666", 
                    borderRadius: "4px", 
                    padding: "8px", 
                }}
                ></textarea>
                  <Button className='btn btn-black' onClick={()=>handleClose(REMARK.current.value)}>Mark as Close</Button></div>}
                </div>
              </div>
            </SidePane>
            
            }
           
    </div>
  );
}
